import { createStore } from 'vuex'

//  Create a new store instance.
const store = createStore({
    state() {
        return {
            ready: false,
            selectedYear:null,
            scale: 1,
        }
    },
    mutations: {
        ready(state) {
            state.ready = true;
        },
        setSelectedYear(state, value) {
            state.selectedYear = value;
        },
        setScaleValue(state, value) {
            state.scale = value;
          },
    },
    getters: {
        ready(state) {
            return state.ready
        },
        getSelectedYear(state) {
            return state.selectedYear;
        },
        getScaleValue(state) {
            return state.scale;
          },
    },
    actions: {
        ready(context) {
            context.commit('ready')
        },
    }
})

export default store;
